import React from 'react';
import PropTypes from 'prop-types'
import EmailModalComponent from '../components/EmailModal';
import { Box, Text, LinkButton } from 'tailwind-react-ui';

const StepComponent = ({src, alt, active, description, step}) =>{

    const [show, setShowModal] = React.useState(false);

    const bg = active ? 'dark-purple': 'light-gray'
    const textColor = active ? 'dark-purple': 'dark-blue'

    return(
        <Box w={'full'} h={'full'}>
            <Box 
            text={['center', 'xl']} 
            className="quicksand-bold step-box" 
            z={'10'} 
            m={'auto'} 
            relative 
            h={10} 
            w={10} 
            p={1} 
            bg={'yellow'} 
            rounded="full">
                {step}
            </Box>
            <Box relative flex m={'auto'} h={32} w={32} bg={bg} rounded="full">
                <img className="flex w-16 max-w-full m-auto" src={src} alt={alt} />
            </Box>
            <Box id="description-box" bg={'white'} m={'auto'} p={{t:4}} text={[textColor, 'center', 'xl']}>
                <Text className="quicksand-bold" tracking={'wide'} font={'bold'}>
                    {description}
                </Text>
                {
                    active ? 
                    <>
                        <br/>
                        <LinkButton 
                        hidden={!active} 
                        style={{borderWidth: '0'}} 
                        className="quicksand-regular text-xl text-yellow"
                        onClick={() => setShowModal(true)}>
                            Lo quiero &gt;
                        </LinkButton>
                    </> : null
                }  
            </Box>
            <EmailModalComponent showModal={show} setShowModal={(show) => setShowModal(show)}/>
        </Box>
    );
}

StepComponent.propTypes = {
    src: PropTypes.src,
    alt: PropTypes.alt,
    description: PropTypes.string,
    step: PropTypes.string,
    active: PropTypes.bool
}

export default StepComponent;